module.exports = __webpack_public_path__ + "img/01271e5de85b9ca8012138534e001d.c72a77f3.jpg";